import { render, staticRenderFns } from "./RPHeaderCard.vue?vue&type=template&id=2ce12345&"
import script from "./RPHeaderCard.vue?vue&type=script&lang=js&"
export * from "./RPHeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./RPHeaderCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports